interface ItemWithOptionalIpi {
  valorIpi?: number | null;
}

const hasOrderItemsIpi = (items: ItemWithOptionalIpi[]): boolean =>
  items.some((item) => item.valorIpi !== undefined && item.valorIpi !== null);

export default hasOrderItemsIpi;
